export { default, FAQResultText } from './FAQSearch';
